import { FUNDING_PROFILE_INFO_TOP_BAR_ID, TOAST_CONTAINER_ID, TOAST_OFFSET } from "@constants/ui";

/**
 * Calculates the additional margin-top (in px) that a toast needs (relative to the
 * toast container) so that it appears immediately below the funding profile top bar
 * plus a small extra offset. If the funding profile top bar is not present, returns 0.
 */
export function getToastOffset({
  toastContainerId = TOAST_CONTAINER_ID,
  fundingProfileTopBarId = FUNDING_PROFILE_INFO_TOP_BAR_ID,
  offset = TOAST_OFFSET,
}: {
  toastContainerId?: string;
  fundingProfileTopBarId?: string;
  offset?: number;
}) {
  const topBar = document.getElementById(fundingProfileTopBarId);
  if (!topBar) return 0;

  // Prefer querying by configured id; fallback to a well-known class on the container
  const toastContainer =
    document.getElementById(toastContainerId) || (document.querySelector(`.${toastContainerId}`) as HTMLElement | null);
  if (!toastContainer) return 0;

  const topBarRect = topBar.getBoundingClientRect();
  const containerRect = toastContainer.getBoundingClientRect();

  // Desired top edge of the toast content: just below the top bar + extra offset
  const desiredTopWithinViewport = topBarRect.bottom + offset;
  // Convert desired viewport position to a margin relative to the container's top
  const marginRelativeToContainer = desiredTopWithinViewport - containerRect.top;

  return Math.max(0, Math.round(marginRelativeToContainer));
}
